/*
 * Suppression groupée des lignes de tatouage.
 *
 * Un tatouage ajoute deux lignes au panier en un seul appel (voir tattoo.js,
 * AddTattooToCartDesktop) : la chaussette, porteuse de TatouageGauche /
 * TatouageDroit, et le service de tatouage. Les deux partagent le même
 * TatouageId. Supprimer l'une sans l'autre laisse soit un service facturé sur
 * rien, soit une chaussette décrivant un tatouage qui n'est plus payé.
 *
 * Ce fichier intercepte le clic sur « Supprimer » en phase de capture, avant
 * que CartRemoveButton (cart.js) ne parte sur sa suppression mono-ligne, et
 * envoie un seul /cart/update.js pour toute la paire.
 *
 * Les lignes sont désignées par leur `key` et non par leur index : supprimer
 * par index décale les lignes suivantes et ferait sauter la mauvaise.
 *
 * Le marquage vient des templates : data-tattoo-id sur la ligne, à côté du
 * data-cart-item existant. Voir snippets/cart-drawer-item.liquid et
 * sections/main-cart-items.liquid.
 */
(function () {
  const ITEM_SELECTOR = '[data-cart-item]';

  function getTattooId(element) {
    const item = element.closest(ITEM_SELECTOR);
    if (!item) return null;
    const id = item.dataset.tattooId;
    return id && id.trim() !== '' ? id.trim() : null;
  }

  /* Les lignes partageant ce TatouageId, dans ce panier-là. Le tiroir et la
     page panier peuvent coexister dans le DOM : on reste dans le conteneur
     d'où vient le clic pour ne pas mélanger leurs clés. */
  function findGroupKeys(cartItems, tattooId) {
    return Array.from(cartItems.querySelectorAll(ITEM_SELECTOR))
      .filter((item) => (item.dataset.tattooId || '').trim() === tattooId)
      .map((item) => item.dataset.cartItem)
      .filter(Boolean);
  }

  /* Les sections que d'autres composants veulent voir rafraîchies en même
     temps (barre de livraison offerte, etc.). Même mécanique que cart.js. */
  function collectGroupedSections() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sections },
      })
    );
    return sections;
  }

  function showError() {
    const errors = document.querySelector('#cart-errors, #CartDrawer-CartErrors');
    if (errors && window.FoxThemeStrings) {
      errors.textContent = window.FoxThemeStrings.cartError;
    }
  }

  function removeGroup(cartItems, keys) {
    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });

    cartItems.enableLoading();

    const body = JSON.stringify({
      updates: updates,
      sections: [
        ...cartItems.getSectionsToRender().map((section) => section.section),
        ...collectGroupedSections(),
      ],
      sections_url: window.location.pathname,
    });

    fetch(window.FoxThemeSettings.routes.cart_update_url, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.errors) {
          showError();
          return;
        }

        const isEmpty = parsedState.item_count === 0;
        const cartDrawer = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        cartItems.classList.toggle('is-empty', isEmpty);
        if (cartDrawer) cartDrawer.classList.toggle('is-empty', isEmpty);
        if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);

        cartItems.renderContents(parsedState);

        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, parsedState);
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: parsedState } })
        );
      })
      .catch(showError)
      .finally(() => {
        cartItems.loading.finish();
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      const removeButton = event.target.closest('cart-remove-button');
      if (!removeButton) return;

      const tattooId = getTattooId(removeButton);
      if (!tattooId) return;

      const cartItems =
        removeButton.closest('cart-items') ||
        removeButton.closest('cart-drawer-items');
      if (!cartItems) return;

      const keys = findGroupKeys(cartItems, tattooId);
      /* Une seule ligne porte cet identifiant : rien de groupé à faire, on
         laisse le thème supprimer normalement. */
      if (keys.length < 2) return;

      /* On prend la main : stopPropagation empêche l'événement d'atteindre le
         <cart-remove-button>, donc son gestionnaire mono-ligne ne part pas. */
      event.preventDefault();
      event.stopPropagation();

      removeGroup(cartItems, keys);
    },
    true // phase de capture : avant le gestionnaire du thème
  );
})();
